import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Actions, ofType } from '@ngrx/effects';
import { FooterItem } from 'src/app/angular-core/components/navigation/footer-base/footer-base.component';
import { FooterService } from 'src/app/angular-core/services/footer.service';
import { FooterItemsService } from 'src/app/services/footer-items.service';
import { AppActionsTypes } from 'src/app/store/actions/app.actions';

@UntilDestroy()
@Component({
  selector: 'xpac-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent implements OnInit {

  public footerItems: FooterItem[] = [];

  constructor(
    private footerItemsService: FooterItemsService,    
    private footerService: FooterService,
    private actionsListener$: Actions,
  ) { }

  public ngOnInit(): void {
    this.setFooterItems();
    // Impersonation causes the permission data to be cleared and reloaded. 
    // Make sure we refresh the footer when this happens.
    this.actionsListener$
      .pipe(
        ofType(AppActionsTypes.CLEAR_PERMISSION_DATA),
        untilDestroyed(this)
      )
      .subscribe(() => {
        // This will wait for the permissions to be loaded again before setting the footer items
        this.setFooterItems();
      });
  }

  private async setFooterItems(): Promise<void> {
    const footerItems: FooterItem[] = await this.footerItemsService.getFooterItemsFooter();

    this.footerItems = footerItems;
    // Set the footeritems in the footerservice
    this.footerService.setFooterItems(this.footerItems);
  }
}